import HotelFullDetailItem from '@/components/App/Hotels/HotelFullDetailItem';
import HotelsMap from '@/components/HotelsMap/HotelsMap';
import React from 'react';
import SearchBoxHotelSearch from './components/SearchBox.HotelSearch';
import FilterBarHotelSearch from './components/FilterBar.HotelSearch';
import { useHistory, useLocation } from 'react-router-dom';
import { generateHotelSearchUrl, getHotelSearchRequest } from '@/urls';
import { apiSdk } from '@/httpClient';
import { AvailableHotelModel, DestinationModel, HotelSearchRequest } from '@/__generated';
import HotelFullDetailLoadingItem from '@/components/App/Hotels/HotelFullDetailItem.Loading';
import { HOTEL_CONFIG, formatDateOnly } from '@/config';
import Spin from '@/components/Spin';
import { GetHotelAvailableParams, IHotelQuery } from './type';
import ReactPaginate from 'react-paginate';
import DefaultHeader from '@/components/App/Header/DefaultHeader';
import { useGetBookmarkHotelCodes } from '@/hooks/dataProvider';
import { useGetQuery } from '@/hooks/useQuery';
import { ModalUtils } from '@/contexts/ModalWrapper';
import SystemAlert from '@/components/App/SystemAlert';
import { BoardType } from '@/constants';
import OrderAndFilterBtns from './components/OrderAndFilterBtns';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import LoadingModal from '@/components/App/Modals/LoadingModal';

type Props = {};
let controller: AbortController | null | undefined;
let allSupplierController: AbortController | null | undefined;

const defaultParams = {
  orderBy: 'cheapestPrice',
  orderByAsc: true,
};
export default function HotelSearchPage({}: Props) {
  const [displayMap, setDisplayMap] = React.useState<boolean>(false);
  const searchPath = useLocation().search;
  const currentSessionId = React.useRef<string | undefined>(undefined);
  const locationCode = useGetQuery('locationCode');
  const history = useHistory();
  const [hotels, setHotels] = React.useState<AvailableHotelModel[]>([]);
  const [totalHotels, setTotalHotels] = React.useState<number>(0);
  const [pageIndex, setPageIndex] = React.useState<number>(1);
  const [getHotelLoading, setHotelLoading] = React.useState<boolean>(true);
  const [displayLoadingModal, setDisplayLoadingModal] = React.useState<boolean>(false);
  const [allProviderIsReady, setAllProviderIsReady] = React.useState(false);
  const [selectedLocation, setSelectedLocation] = React.useState<DestinationModel>();
  const [searchAvailableParams, setAvailableParams] = React.useState<GetHotelAvailableParams>(defaultParams as any);
  const [isUnAvailable, setIsUnAvailable] = React.useState(false);
  const { data: bookmarkHotelCodes } = useGetBookmarkHotelCodes();
  const [hotelQuery, setHotelQuery] = React.useState<IHotelQuery>();
  const [displaySearchOnMobile, setDisplaySearchOnMobile] = React.useState(false);
  React.useEffect(() => {
    if (locationCode) {
      getLocationDetail(locationCode);
    }
  }, [locationCode]);

  React.useEffect(() => {
    let request = getHotelSearchRequest(searchPath);
    if (!request) {
      window.location.href = '/';
      return;
    }
    setIsUnAvailable(false);
    if (request.sessionId) {
      if (currentSessionId.current !== request.sessionId) {
        searchData(request, request.sessionId);
      }
    } else {
      searchData(request, undefined);
    }
  }, [searchPath]);

  const getLocationDetail = (locationCode: string) => {
    apiSdk.HotelDestinationService.getDestination({ code: locationCode }).then(res => {
      setSelectedLocation(res);
    });
  };

  const getHotels = (searchParams: Partial<GetHotelAvailableParams>, currentPage: number = 1, setIsUnAvailableIfNoData: boolean = false) => {
    setHotelLoading(true);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    apiSdk.BookingService.getHotels({
      ...searchParams,
      sessionId: currentSessionId.current || '',
      pageSize: HOTEL_CONFIG.defaultPageSize,
      pageIndex: currentPage,
    } as any)
      .then(res => {
        if (res.sessionExpired) {
          onSessionExpired();
        } else {
          if (res.total === 0 && setIsUnAvailableIfNoData) {
            setIsUnAvailable(true);
          }
          setHotels(res.data || []);
          setTotalHotels(res.total || 0);
          setPageIndex(res.pageIndex || 1);
        }
      })
      .catch(() => {
        setHotels([]);
      })
      .finally(() => {
        setHotelLoading(false);
        setDisplayLoadingModal(false);
      });
  };
  const onSessionExpired = () => {
    ModalUtils.info({
      title: 'Session expired',
      content: 'Your search session expired, we will create new search session for you!',
      onClose: () => {
        let request = getHotelSearchRequest(searchPath);
        if (!request) {
          window.location.href = '/';
          return;
        }
        setAvailableParams(defaultParams as any);
        searchData(request, undefined);
      },
    });
  };
  React.useEffect(() => {
    console.log('displayLoadingModal', displayLoadingModal);
  }, [displayLoadingModal]);

  const searchData = (request: HotelSearchRequest, sessionId: string | undefined) => {
    setDisplayLoadingModal(true);
    setIsUnAvailable(false);
    setAllProviderIsReady(false);
    if (controller) {
      controller.abort();
    }
    controller = new AbortController();
    currentSessionId.current = undefined;
    apiSdk.BookingService.searchHotels(
      {
        body: {
          ...request,
          rooms: request.rooms?.map((r, index) => ({ ...r, roomIndex: index })),
          checkinDate: formatDateOnly(request.checkinDate) as any,
          checkoutDate: formatDateOnly(request.checkoutDate) as any,
          sessionId: sessionId,
        },
      },
      { signal: controller.signal },
    )
      .then(searchResponse => {
        history.push(
          generateHotelSearchUrl({ ...request, provider: searchResponse.ntaHotelAvailable ? 'nta' : undefined }, searchResponse.sessionId),
        );
        if (!searchResponse.success) {
          setIsUnAvailable(true);
          setDisplayLoadingModal(false);
          return;
        }
        if (!searchResponse.allSuppliers && !searchResponse.ntaHotelAvailable) {
          setIsUnAvailable(true);
          setDisplayLoadingModal(false);
          return;
        }

        currentSessionId.current = searchResponse.sessionId;

        setHotelQuery({
          ...searchResponse.hotelQuery,
          allSuppliers: searchResponse.allSuppliers,
        });
        var boardTypes = searchResponse.hotelQuery?.boardType ? [BoardType.__getValue(searchResponse.hotelQuery?.boardType)] : [];
        setAvailableParams({ boardTypes: boardTypes, sessionId: searchResponse.sessionId || '', ...(defaultParams as any) });
        if (searchResponse.ntaHotelAvailable) {
          getHotels({ boardTypes: boardTypes, ...defaultParams } as any, 1);
          if (searchResponse.allSuppliers) {
            tryOtherSupplierHotels(searchResponse.sessionId || '', boardTypes, false);
          }
        } else {
          if (searchResponse.allSuppliers) {
            tryOtherSupplierHotels(searchResponse.sessionId || '', boardTypes, true);
          }
        }
      })
      .catch(err => {
        if (!axios.isCancel(err)) {
          setIsUnAvailable(true);
          setDisplayLoadingModal(false);
        }
        controller = undefined;
      });
  };

  const tryOtherSupplierHotels = (sessionId: string, boardTypes: string[], needGetHotel: boolean) => {
    if (allSupplierController) {
      allSupplierController.abort();
    }
    allSupplierController = new AbortController();
    if (needGetHotel && !allProviderIsReady) {
      setDisplayLoadingModal(true);
    }
    apiSdk.BookingService.getAllSuppliersAvailableHotelStatus({ sessionId: sessionId }, { signal: allSupplierController.signal })
      .then(status => {
        if (sessionId === currentSessionId.current) {
          setAllProviderIsReady(true);
          if (needGetHotel) {
            setAvailableParams(x => ({ ...x, allSuppliers: true, sessionId: sessionId, ...(defaultParams as any) }));
            getHotels({ boardTypes: boardTypes, allSuppliers: true, ...(defaultParams as any) }, 1, true);
          }
        }
      })
      .catch(() => {})
      .finally(() => {});
  };
  const onSearchHotel = (request: HotelSearchRequest) => {
    currentSessionId.current = undefined;
    searchData(request, undefined);
    setAvailableParams(defaultParams as any);
  };

  const onFilterChange = (params: Partial<GetHotelAvailableParams>, clearAllFilter?: boolean) => {
    let newSearchParams: any = { ...searchAvailableParams, ...params };
    if (clearAllFilter) {
      newSearchParams = {
        ...params,
        boardTypes: hotelQuery?.boardType ? [BoardType.__getValue(hotelQuery?.boardType)] : undefined,
        ...defaultParams,
      };
    }
    setAvailableParams(newSearchParams as any);
    getHotels(newSearchParams, 1);
  };

  const onProviderChange = (isAllProvider: boolean) => {
    let request = getHotelSearchRequest(searchPath);
    if (request) {
      history.push(generateHotelSearchUrl({ ...request, provider: isAllProvider ? undefined : 'nta' }, currentSessionId.current));
    }

    if (isAllProvider) {
      setHotelLoading(true);
      let newSearchParams: any = {
        allSuppliers: isAllProvider,
        boardTypes: hotelQuery?.boardType ? [BoardType.__getValue(hotelQuery?.boardType)] : undefined,
        ...defaultParams,
      };
      setAvailableParams(newSearchParams as any);
      tryOtherSupplierHotels(currentSessionId.current || '', hotelQuery?.boardType ? [BoardType.__getValue(hotelQuery?.boardType)] : [], true);
    } else {
      let newSearchParams: any = {
        allSuppliers: isAllProvider,
        boardTypes: hotelQuery?.boardType ? [BoardType.__getValue(hotelQuery?.boardType)] : undefined,
        ...defaultParams,
      };
      setAvailableParams(newSearchParams as any);
      getHotels(newSearchParams, 1);
    }
  };

  const onOrderChange = (orderBy: string, orderByAsc: boolean) => {
    let newSearchParams = { ...searchAvailableParams, orderBy: orderBy, orderByAsc: orderByAsc } as any;
    getHotels(newSearchParams, 1);
    setAvailableParams(newSearchParams);
  };

  const onPageChange = (selectedItem: { selected: number }) => {
    getHotels(searchAvailableParams || {}, selectedItem.selected + 1);
  };
  const isDisplaySkeletonLoading = React.useMemo(() => {
    if (displayLoadingModal) {
      return true;
    }
    if (!currentSessionId.current) {
      return true;
    }
    if (getHotelLoading) {
      return true;
    }
    return false;
  }, [getHotelLoading, displayLoadingModal, hotels, currentSessionId.current]);
  return (
    <div>
      <DefaultHeader />

      <Helmet>
        <title>{`Hotels in ${selectedLocation?.name || ''}`}</title>
      </Helmet>
      {displayLoadingModal ? <LoadingModal centered subTitle="Searching for the best stays, just a moment..." /> : null}

      {displayMap && currentSessionId.current ? (
        <HotelsMap
          hotelQuery={hotelQuery}
          onClose={() => setDisplayMap(false)}
          sessionId={currentSessionId.current}
          onSessionExpired={onSessionExpired}
          onProviderChange={onProviderChange}
          params={searchAvailableParams}
        />
      ) : null}
      <SearchBoxHotelSearch onSearchHotel={onSearchHotel} />
      {isUnAvailable ? (
        <section className="mt-20">
          <div className="container">
            <div className="layout-pt-md layout-pb-md border-light rounded-4 text-center mb-20" style={{ backgroundColor: '#f0f8ff' }}>
              <img className="pb-30 " src="/static/icons/search-hotel.svg" alt="search hotel" style={{ width: 100 }} />
              <div className="fw-500 text-18">
                We couldn't find any results that match your search criteria.
                <br /> Please modify your search and try again.
              </div>
            </div>
          </div>
          <div className="container"></div>
        </section>
      ) : (
        <div>
          <SystemAlert className="bg-error-1" />
          <section className="layout-pt-sm layout-pb-md">
            <div className="container">
              <div className="row y-gap-30">
                <FilterBarHotelSearch
                  onProviderChange={onProviderChange}
                  hotelQuery={hotelQuery}
                  params={searchAvailableParams}
                  sessionId={currentSessionId.current}
                  setDisplayMap={setDisplayMap}
                  isLoading={isDisplaySkeletonLoading}
                  onFilterChange={onFilterChange}
                  displaySearchOnMobile={displaySearchOnMobile}
                  onCloseFilterOnMobile={() => setDisplaySearchOnMobile(false)}
                />

                <div className="col-xl-9 col-xs-12 col-md-12">
                  <OrderAndFilterBtns
                    orderBy={searchAvailableParams?.orderBy}
                    orderByAsc={!!searchAvailableParams?.orderByAsc}
                    onOrderChange={onOrderChange}
                    searchHotelLoading={isDisplaySkeletonLoading}
                    selectedLocationName={selectedLocation?.name || ''}
                    totalHotels={totalHotels}
                    openSearchOnMobile={() => setDisplaySearchOnMobile(true)}
                  />

                  <div className="row y-gap-30 mt-10">
                    {isDisplaySkeletonLoading ? (
                      <HotelFullDetailLoadingItem count={10} />
                    ) : (
                      <>
                        {hotels.length ? (
                          <div>
                            {hotels.map(hotel => {
                              return <HotelFullDetailItem bookmarkHotelCodes={bookmarkHotelCodes} hotel={hotel} key={hotel.hotelCode} />;
                            })}
                          </div>
                        ) : !getHotelLoading ? (
                          <section>
                            <div className="container">
                              <div
                                className="layout-pt-md layout-pb-md border-light rounded-4 text-center mb-20 "
                                style={{ backgroundColor: '#f0f8ff' }}
                              >
                                <div className="fw-500 text-18">
                                  We couldn't find any results that match your search criteria.
                                  <br /> Please modify your search and try again.
                                </div>
                              </div>
                            </div>
                          </section>
                        ) : null}
                      </>
                    )}
                  </div>
                  {totalHotels && totalHotels > HOTEL_CONFIG.defaultPageSize && !displayLoadingModal && !getHotelLoading ? (
                    <div className="border-top-light mt-30 pt-30">
                      <div className="row x-gap-10 y-gap-20 justify-between md:justify-center">
                        <div className="d-flex  justify-center item-center ">
                          <ReactPaginate
                            className="hotel-list-paginate"
                            breakLabel="..."
                            previousLabel={
                              <button className="button -blue-1 size-40 rounded-full border-light p-10">
                                <i className="icon-chevron-left text-12" />
                              </button>
                            }
                            nextLabel={
                              <button className="button -blue-1 size-40 rounded-full border-light">
                                <i className="icon-chevron-right text-12" />
                              </button>
                            }
                            onPageChange={onPageChange}
                            pageRangeDisplayed={5}
                            forcePage={(pageIndex || 1) - 1}
                            pageCount={Math.ceil(totalHotels / HOTEL_CONFIG.defaultPageSize)}
                            renderOnZeroPageCount={null}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </div>
  );
}
